export default __webpack_public_path__ + "static/media/arrow-left.8d6cc6bd.svg";